/**** cat.Branch */
import { apiTypes } from 'shared/consts/handbooksApiTypes';

const config = {
  schema: 'mgt',
  table: 'Depot',
  title: 'Филиалы',
  apiType: apiTypes.DEFAULT,
  elemsOnPage: 100,
  connections: {
    agencies: {
      apiType: apiTypes.DEFAULT,
      schema: 'mgt',
      table: 'Agency',
      index: 'agency_id',
      fields: ['title'],
      format: (elem: any) => elem['title'],
    },
  },
  fields: [
    {
      name: 'depot_id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px',
    },
    {
      name: 'depot_name',
      title: 'Наименование',
      type: 'text',
      required: true,
    },
    {
      name: 'address',
      title: 'Адрес',
      type: 'text',
      required: false,
    },
    {
      name: 'phone',
      title: 'Телефон',
      type: 'text',
      required: false,
    },
    {
      name: 'agency_id',
      title: 'Предприятие перевозчика',
      type: 'number',
      required: true,
      connection: 'agencies',
    },
    {
      name: 'dp_lat',
      title: 'Широта',
      type: 'text',
      required: false,
      hide: true,
    },
    {
      name: 'dp_lon',
      title: 'Долгота',
      type: 'text',
      required: false,
      hide: true,
    },
    {
      title: 'Координаты',
      type: 'composite',
      disableSort: true,
      composite: {
        type: 'point_coords',
        lat: 'dp_lat',
        lon: 'dp_lon',
      },
    },
    {
      name: 'do_not_update',
      title: 'Отключить автообновление',
      type: 'boolean',
      required: false,
      width: '205px',
    },
  ],
  newTemplate: {
    depot_id: null,
    agency_id: null,
    depot_name: '',
    do_not_update: true,
  },
  makeIdOnInsert: true,
  updateField: 'update_date',
  defaultSort: {
    field: 'depot_id',
    direction: 'desc',
  },
  import: {
    header: [
      {
        title: 'depot_id',
        field: 'depot_id',
      },
      {
        title: 'depot_name',
        field: 'depot_name',
      },
      {
        title: 'depot_adress',
        field: 'address',
      },
      {
        title: 'depot_phone',
        field: 'phone',
      },
      {
        title: 'agency_id',
        field: 'agency_id',
      },
      {
        title: 'dp_lat',
        field: 'dp_lat',
      },
      {
        title: 'dp_lon',
        field: 'dp_lon',
      },
    ],
    example: `1;Название филиала;Адрес филиала;Телефон филиала;1;59.918077;30.304900`,
  },
  export: {
    fields: [
      {
        name: 'depot_name',
        title: 'Наименование',
      },
      {
        name: 'address',
        title: 'Адрес',
      },
      {
        name: 'phone',
        title: 'Телефон',
      },
      {
        name: 'agency_id',
        title: 'Предприятие перевозчика',
        connectionGetField: 'title',
      },
      {
        name: 'coords',
        title: 'Координаты',
        format: {
          fields: ['dp_lat', 'dp_lon'],
          template: '%1;%2',
        },
        defaultValue: '000.00000;000.00000'
      },
    ],
  },
};

export default config;
